var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h3", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading... "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized
                    ? _c("div", [
                        _c(
                          "form",
                          {
                            attrs: { id: "weights-set-editor-form" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.emitFormSubmit.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Name:")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.vm.name,
                                    expression: "vm.name",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  required: "",
                                  minlength: "2",
                                  maxlength: "100",
                                },
                                domProps: { value: _vm.vm.name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.vm,
                                      "name",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "error" }, [
                                _vm._v(_vm._s(_vm.nameError)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass: "table table-bordered table-hover",
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.criteria, function (c) {
                                    return _c("tr", { key: c.id }, [
                                      _c("td", [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(c.name)
                                        ),
                                        _c("br"),
                                        _c("small", [_vm._v(_vm._s(c.path))]),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        c.isGoal
                                          ? _c("input", {
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "number",
                                                disabled: "",
                                                value: "100",
                                              },
                                            })
                                          : _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: c.inputValue,
                                                  expression: "c.inputValue",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                step: "any",
                                              },
                                              domProps: { value: c.inputValue },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    c,
                                                    "inputValue",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "error" }, [
                                          _vm._v(_vm._s(_vm.getError(c.id))),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        c.isGoal
                                          ? _c("span", [_vm._v("100")])
                                          : _c("span", [
                                              !_vm.hasDirtyWeights
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(c.localWeight) +
                                                        "\n                                                "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        c.isGoal
                                          ? _c("span", [_vm._v("100")])
                                          : _c("span", [
                                              !_vm.hasDirtyWeights
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(c.globalWeight) +
                                                        "\n                                                "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]),
                                      ]),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _vm.hasDirtyWeights
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-warning",
                          attrs: { type: "button" },
                          on: { click: _vm.emitNormalizeWeights },
                        },
                        [_vm._v("Normalize")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        form: "weights-set-editor-form",
                      },
                    },
                    [_vm._v("Save")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Criterion")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "150px" }, attrs: { rowspan: "2" } }, [
          _vm._v("Input"),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [
          _vm._v("Normalized weight [%]"),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", { staticStyle: { width: "150px" } }, [_vm._v("Local")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "150px" } }, [_vm._v("Global")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }